import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import RequestAd from '../advideo/RequestAd';
import AdCount from '../advideo/Adcount';
import AdStat from '../vStat';
import AdCore from './AdCore';
import AdPlaying from './AdPlaying';

class AdBehind extends PureComponent {
    static propTypes = {
        option: PropTypes.object.isRequired,
        videoinfo: PropTypes.object.isRequired,
        playermsg: PropTypes.object.isRequired,
        trigger: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.playFlag = false;
        this.sendStartMap = new Map();
        this.sendPlayMap = new Map();
        this.wrapRef = React.createRef();
        this.state = {
            adList: [],
            countdown: 0,
            playIndex: -1,
            canPlaySounds: true,
            clickPlaySounds: true,
        };
    }

    componentDidMount() {
        const { option, videoinfo } = this.props;
        const ad = new RequestAd(option, videoinfo);

        Promise.race([
            new Promise((resolve, reject) => {
                ad.on('start', (data, originAd) => {
                    const { behindAd } = data;
                    const adList = [];
                    let countdown = 0;

                    if (behindAd && Array.isArray(behindAd.adUrl)) {
                        countdown = behindAd.adTime;

                        behindAd.adUrl.map((item, index) => {
                            adList.push({
                                adUrl: behindAd.adUrl[index],
                                clickUrl: behindAd.clickUrl[index],
                                oneadTime: behindAd.oneadTime[index],
                                vol: behindAd.vol[index],
                                materialType: behindAd.materialType[index],
                                materialWidth: behindAd.materialWidth[index],
                                materialHeight: behindAd.materialHeight[index],
                            });
                        });
                    }

                    if (adList.length) {
                        resolve({ adList, countdown, behindAd, originAd });
                    } else {
                        reject({ code: 0, msg: '无后贴片数据' });
                    }
                });
            }),
            new Promise((resolve, reject) => {
                setTimeout(() => {
                    reject({ code: 1, msg: '后贴片数据请求超时' });
                }, 4000);
            }),
        ])
            .then((data) => {
                const { adList, countdown, behindAd, originAd } = data;

                this.adCount = new AdCount(originAd);
                this.adStat = new AdStat(videoinfo);
                this.statData = behindAd;
                this.adTime = countdown;
                this.setState({ adList, countdown });
            })
            .catch((e) => {
                console.error(e.msg);
                this.props.trigger('ended');
            });
    }

    handleCanplay = (index) => {
        if (!this.playFlag && index === 0) {
            this.setState({ playIndex: 0 });
            this.adStat.sendVplayer('701010');
            this.playFlag = true;
        }
    };

    handleTimeupdate = ({ index, currentTime }) => {
        this.adCurrentTime = currentTime;
        // 倒计时更新
        this.setState({ countdown: Math.max(0, Math.round(this.adTime - currentTime)) });

        // 计数统计相关
        this.adCount.send(9, index, currentTime);
        if (!this.sendStartMap.has(index)) {
            this.adStat.sendAd('start', '000', this.statData, index);
            this.sendStartMap.set(index, true);
        }

        if (Math.floor(currentTime) === 3 && !this.sendPlayMap.has(index)) {
            this.adStat.sendAd('play', '000', this.statData, index);
            this.sendPlayMap.set(index, true);
        }
    };

    handleEnded = ({ index, currentTime }) => {
        this.adCurrentTime = currentTime;
        const { adList } = this.state;

        // 倒计时更新
        this.adTime = Math.max(0, Math.round(this.adTime - currentTime));
        // 发送播放器广告播放完成统计
        this.adStat.sendAd('finish', '000', this.statData, index);

        if (index < adList.length - 1) {
            this.setState({ playIndex: index + 1 });
        } else if (index === adList.length - 1) {
            this.props.trigger('ended');
        }
    };

    handleChangeCanPlaySounds = (canPlaySounds) => {
        this.setState({ canPlaySounds });
    };

    handleChangeClickPlaySounds = (clickPlaySounds) => {
        this.setState({ clickPlaySounds });
    };

    handleChangePlaySounds = ({ canPlaySounds, clickPlaySounds }) => {
        this.setState({ canPlaySounds, clickPlaySounds });
    };

    handleAdLinkClick = (index, clickData) => {
        this.adStat.sendAd('click', '000', this.statData, index);
        this.adCount.sendClick(9, index, clickData, '2', this.adCurrentTime);
    };

    handlePlaySoundsCount = (data) => {
        const { startTime, endTime, pointerClientX, pointerClientY, currentPlaySounds } = data;
        const { playIndex } = this.state;
        const actionId = currentPlaySounds ? '6' : '5';

        try {
            const {
                x: adLinkX,
                y: adLinkY,
                width: adSpaceWidth,
                height: adSpaceHeight,
            } = this.wrapRef.current.getBoundingClientRect();
            const offsetX = pointerClientX - adLinkX;
            const offsetY = pointerClientY - adLinkY;
            const clickData = {
                startTime,
                endTime,
                adSpaceWidth,
                adSpaceHeight,
                offsetX,
                offsetY,
            };

            this.adCount.sendClick(9, playIndex, clickData, actionId, this.adCurrentTime);
        } catch (e) {
            console.error(e);
        }
    };

    render() {
        const { playermsg } = this.props;
        const { width: playerWidth, height: playerHeight } = playermsg;
        const { adList, countdown, playIndex, canPlaySounds, clickPlaySounds } = this.state;

        return adList.length ? (
            <div className={styles.wrap} ref={this.wrapRef}>
                <AdCore
                    content={{
                        playerWidth,
                        playerHeight,
                        adList,
                        playIndex,
                        canPlaySounds,
                        clickPlaySounds,
                        countdown,
                    }}
                    methods={{
                        handleCanplay: this.handleCanplay,
                        handleTimeupdate: this.handleTimeupdate,
                        handleEnded: this.handleEnded,
                        handleChangeCanPlaySounds: this.handleChangeCanPlaySounds,
                        handleAdLinkClick: this.handleAdLinkClick,
                    }}
                />
                <AdPlaying
                    content={{
                        countdown,
                        canPlaySounds,
                        clickPlaySounds,
                    }}
                    methods={{
                        handleChangeClickPlaySounds: this.handleChangeClickPlaySounds,
                        handleChangePlaySounds: this.handleChangePlaySounds,
                        handlePlaySoundsCount: this.handlePlaySoundsCount,
                    }}
                />
            </div>
        ) : null;
    }
}

export default AdBehind;
